module.exports = __webpack_public_path__ + "img/logo_white_z.ca75113f.png";